module.exports = __webpack_public_path__ + "img/tab23-1.7823f601.jpg";